import axios from 'axios';
import { Message } from 'element-ui';

const apiBase = process.env.VUE_APP_API_BASE_URL || '';
// 创建 axios 实例（与 axios-config 中 baseURL 规则一致）
const service = axios.create({
  baseURL: apiBase ? apiBase.replace(/\/?$/, '/') : '',
  timeout: 10000
});

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 所有错误统一处理
    if (error.message) {
      Message.error(error.message);
    }
    return Promise.reject(error);
  }
);

export default service;
